<template>
	<article
		class="section section--floating section--full">
		<div>
			<header>
				<h1 class="beta" v-html="check.label"/>
			</header>
			<dl class="flex flex-wrap content-between gap-2">
				<div>
					<dt class="heavy">Status</dt>
					<dd>
						<status-badge :status="check.status" group="health"/>
					</dd>
				</div>
				<div>
					<dt class="heavy">Current State</dt>
					<dd>
						<progress-indicator
							class="metrics__metric--progress--small metrics__metric--progress--no-title"
							title-prefix="Disk Capacity"
							:title-suffix="null"
							:percentage="check.meta.data.capacity"/>
					</dd>
				</div>
				<div>
					<dt class="heavy">Reason For Status</dt>
					<dd>
						<OutcomeBadge
							class="outcome--horizontal outcome--open outcome--small"
							:result="check.status === 'ok'" :message="check.notificationMessage"/>
					</dd>
				</div>
			</dl>
		</div>
		<!--		<div class="flex gap-2 mt-2">-->
		<!--			<dl class="detail-list">-->
		<!--				<div-->
		<!--					v-for="(metaValue, metaKey) in check.meta" :key="metaKey" class="detail-list__item">-->
		<!--					<dt class="heavy" v-html="metaKey"/>-->
		<!--					<dd v-html="metaValue"/>-->
		<!--				</div>-->
		<!--			</dl>-->
		<!--		</div>-->
	</article>
</template>
<script>
import OutcomeBadge from "../../../../../../common/components/OutcomeBadge";

export default {
	components: {
		OutcomeBadge,
	},

	props: {
		check: {
			required: true,
			type: Object,
		}
	},
};
</script>
